import * as React from 'react';

// tslint:disable:max-line-length
export const PlusIcon: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>Плюс</title>
    <path
      d="M7.99 7.99H1.938c-.561 0-1.01.453-1.01 1.01 0 .561.453 1.01 1.01 1.01h6.054v6.053c0 .561.452 1.01 1.009 1.01.561 0 1.01-.453 1.01-1.01v-6.054h6.053c.561 0 1.01-.452 1.01-1.009 0-.561-.453-1.01-1.01-1.01h-6.054V1.938c0-.561-.452-1.01-1.009-1.01-.561 0-1.01.453-1.01 1.01v6.054z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);
